export default __webpack_public_path__ + "static/paymentlink3-60e4ef2e4362e214dbaee11f66346ac1.png";